var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticStyle:{"margin-bottom":"30px"},attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.currentNav),function(item,index){return _c('el-breadcrumb-item',[_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(item))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }